import React from "react";

function Footer() {
  return (
    <div>
      <footer className="main-footer">
        <strong>  
          Copyright © 2014-2021 <a href=" ">Crm Bizavtar </a>.
        </strong>
        All rights reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 3.2.0
        </div>
      </footer>
      {/* Control Sidebar */}
    </div>
  );
}

export default Footer;
